module.exports = __webpack_public_path__ + "static/img/pggpgp.8103338b.png";